var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(2261.5 17593.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(-3289 -18297.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(1030 706.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M75,0A75,75,0,1,1,0,75,75,75,0,0,1,75,0Z",
    transform: "translate(0 0.088)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M59,0A59,59,0,1,1,0,59,59,59,0,0,1,59,0Z",
    transform: "translate(16 9.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(0 0.088)",
    fill: "none",
    stroke: "#00a9ac",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M-96.043,229.394h-32.74c0-1.2-.019-2.373,0-3.546.04-2.035.12-4.07.145-6.106a.961.961,0,0,0-.381-.662,16.339,16.339,0,0,1-6.7-10.367A16.243,16.243,0,0,1-123.271,189.8c6.726-1.344,12.465.509,16.811,6a16.982,16.982,0,0,1,2.693,6.207q3.731,13.337,7.527,26.657C-96.174,228.9-96.115,229.126-96.043,229.394Zm-29.893-31.771a2.935,2.935,0,0,0-2.949,3.014,2.933,2.933,0,0,0,3.013,2.951,2.945,2.945,0,0,0,2.953-3.014A2.95,2.95,0,0,0-125.936,197.624Zm-6.689-4.866a17.951,17.951,0,0,1,14.944-5.244,17.691,17.691,0,0,1,12.873,7.212c.254.339.455.5.9.363a6.065,6.065,0,0,0,4.187-5.82,6.008,6.008,0,0,0-4.545-5.67,6.393,6.393,0,0,0-3.664.235c-.058-3.463-1.569-5.972-4.8-7.152-3.131-1.143-5.83-.2-8.057,2.226-3.2-3.27-6.947-4.346-11.2-2.4a8.794,8.794,0,0,0-5.371,8.276,9.121,9.121,0,0,0,4.473,8.172C-132.761,192.864-132.687,192.817-132.626,192.758Zm-4.139,20.422a19.385,19.385,0,0,0-4.8,8.094,4.745,4.745,0,0,0,.844,4.4c2.175,2.869,6.624,3.4,9.612,1.576a.8.8,0,0,0,.291-.579q.1-2.952.145-5.906a1.008,1.008,0,0,0-.3-.646c-.516-.5-1.094-.942-1.609-1.446a18.363,18.363,0,0,1-3.912-5.706C-136.632,213.072-136.705,213.119-136.765,213.18Zm.778-15.853-13.865,6.655,12.338,5.921A18.7,18.7,0,0,1-135.987,197.327Z",
    transform: "translate(1224.852 579.034)",
    fill: "#00a9ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcc);
export default __webpack_public_path__ + "static/media/ccc.9144963143d8b3e1aa054f0b6a7dd138.svg";
export { ForwardRef as ReactComponent };